import React from 'react';
import { Link } from 'react-router-dom';
import { useProducts } from '../../Context/ProductProvider';
import { actionTypes } from '../../Context/actionTypes';
import { toast } from 'react-hot-toast';

const SliderProduct = ({ product }) => {
    // const navigate = useNavigate()
    // const redirectToDetails = () => {
    //     navigate(`/single-product/${product.id}`)
    // }

    const { state: { cart }, dispatch } = useProducts();

    const addToCart = () => {
        dispatch({ type: actionTypes.ADD_TO_CARD, payload: product })
        toast.success('Add to cart successfully');
    }
    const removeToCart = () => {
        dispatch({ type: actionTypes.REMOVE_FROM_CART, payload: product })

        toast.success('Remove from cart');
    }
    return (
        <div className="bg-white relative lg:w-full group hover:shadow-sm transition">
           
            <Link to={`/single-product/${product.id}`} className='link no-underline'>
            <div className={`badge badge-md absolute inset-1/4 left-0 z-10 rounded-none border-0 ${product?.offer_price ? 'block' : 'hidden'} bg-orange-500`}>-{Math.ceil((product?.price - product?.offer_price) / product?.price * 100)}%</div>
            <div className="relative h-52  object-contain">
            {product.stock === 0 && (
                <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50">
                    <span className="text-white text-2xl font-semibold z-20">Out of stock</span>
                </div>
            )}
                <img src={product?.main?.original_url} alt="product 1" className="p-3 object-cover item-thumbnail w-full h-full"/>
            </div>
            <div className="pt-4 pb-3 px-4 text-left">
            
                {/* <button onClick={() => redirectToDetails(product.id)} className='link no-underline'> */}
                {/* <button onClick={() => redirectToDetails(product.id)} className="link no-underline"> */}
                {/* <button onClick={() => redirectToDetails(product.id)} className="link no-underline"> */}
                {/* <button onClick={() => redirectToDetails(product.id)} className="link no-underline"> */}
               
                {/* <button onClick={() => redirectToDetails(product.id)} className="link no-underline"> */}
                {/* <button onClick={() => redirectToDetails(product.id)} className="link no-underline"> */}
                {/* <button onClick={() => redirectToDetails(product.id)} className="link no-underline"> */}
                    <h4 className="font-medium text-left lg:text-xl sm:text-lg mb-2 text-gray-800 hover:text-primary transition truncate lg:w-52 sm:w-32">{product?.name.charAt(0).toUpperCase() + product?.name.slice(1)}</h4>
                {/* </button> */}
                <div className="flex items-baseline mb-1 space-x-2">
                    <p className="lg:text-lg sm:text-sm text-primary font-semibold"><span className='text-[25px] font-bold'>৳</span>{product?.offer_price ? Math.ceil(product?.offer_price) : Math.ceil(product?.price)}</p>
                    <p className="text-sm text-gray-400 line-through">{product?.offer_price ? "৳" + Math.round(product?.price) : ""}</p>
                </div>
            </div>
            </Link>

            {
                cart?.some(cartProduct => cartProduct?.id === product?.id) ? (
                    <button onClick={removeToCart} className="block lg:text-lg sm:text-sm w-full mt-4 py-2 text-center text-white bg-gradient-to-l from-red-500 to-[#52a3eb] hover:from-[red] hover:to-primary ease-in-out delay-150 duration-300 transition">
                        Remove From Cart
                    </button>
                ) : (
                    <button onClick={addToCart} className={`block lg:text-lg sm:text-sm w-full mt-4 py-2 text-center text-white bg-gradient-to-l from-primary to-[#52a3eb] hover:from-[#52a3eb] hover:to-primary ease-in-out delay-150 duration-300 transition ${product?.stock === 0 ? 'disabled:cursor-not-allowed' : ''}`} disabled={product?.stock === 0}>
                        {product?.stock === 0 ? 'Out of Stock' : 'Add to Cart'}
                    </button>
                )
            }

        </div>
    );
};

export default SliderProduct;

// {Math.floor((product?.offer_price / product?.price) * 100)}